export default {"src":"/_next/static/media/zcl.405b3fc4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};